// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import {jwtDecode} from "jwt-decode"; // ✅ Make sure this is installed
//  import "../Styles/TicketBooking.css";
//  import axios from "axios";

// const TicketBooking = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [fees, setFees] = useState(null);
//   const searchDetails = location.state?.flight || {};
//   const paxDetails = location.state?.seats || {};
//   const updatedExtraAmount=location.state?.updatedPrice || {};
//   console.log("updated extra amount is", updatedExtraAmount);
//   const {
//     origin = "N/A",
//     destination = "N/A",
//     airline = "N/A",
//     departure_date = "N/A",
//     departure_time = "N/A",
//     arival_time = "N/A",
//     pnr = "N/A",
//     sector = "N/A",
//     flight_number = "N/A",
//     flight_route = "N/A",
//     ticket_id = "N/A",
//     price = 0,
//     infant_price = 0,
//   } = searchDetails;

//   const airlineLogos = {
//     SpiceJet: "https://airiq.in/img/spicejet.png",
//     IndiGo: "https://airiq.in/img/indigo.png",
//     Vistara: "https://airiq.in/img/vistara.png",
//     AirIndia: "https://airiq.in/img/airindia.png",
//   };

//   const airlineLogo = airlineLogos[airline] ||
//     "https://thumbs.dreamstime.com/b/small-airplane-flight-4023457.jpg";

//   const [passengerData, setPassengerData] = useState(() => {
//     const adults = Array.from({ length: paxDetails.adults || 1 }, () => ({
//       passengerType: "adult",
//       passengerPrefix: "Mr.",
//       passengerFirstName: "",
//       passengerLastName: "",
//     }));
//     const children = Array.from({ length: paxDetails.children || 0 }, () => ({
//       passengerType: "child",
//       passengerPrefix: "Mstr.",
//       passengerFirstName: "",
//       passengerLastName: "",
//     }));
//     return [...adults, ...children];
//   });
// //https://b2bbackend.dxbhabibi.com/
//   const fetchFees = async () => {
//     try {
//       const response = await fetch("https://b2bbackend.dxbhabibi.com/api/b2/b2b.rou.u1e2r3/gat345fes");
//       const data = await response.json();
//       if (data.status === "success" && data.fees.length > 0) {
//         setFees(data.fees[0]);
//       } else {
//         console.error("No fees available or invalid response");
//       }
//     } catch (error) {
//       console.error("Error fetching fees:", error);
//     }
//   };

//   useEffect(() => {
//     fetchFees();
//   }, []);

//   const handlePassengerChange = (index, e) => {
//     const { name, value } = e.target;
//     const updatedPassengerData = [...passengerData];
//     updatedPassengerData[index] = {
//       ...updatedPassengerData[index],
//       [name]: value,
//     };

//     if (name === "passengerType") {
//       updatedPassengerData[index].passengerPrefix =
//         value === "adult" ? "Mr." : value === "child" ? "Mstr." : "";
//     }

//     const adultCount = updatedPassengerData.filter((p) => p.passengerType === "adult").length;
//     const infantCount = updatedPassengerData.filter((p) => p.passengerType === "infant").length;

//     if (name === "passengerType" && value === "child" && infantCount >= adultCount) {
//       Swal.fire("Validation error", "Each infant must be accompanied by an adult. Removing extra infants.", "error");
//       updatedPassengerData.splice(updatedPassengerData.findIndex(p => p.passengerType === "infant"), 1);
//     }

//     setPassengerData(updatedPassengerData);
//   };

//   const addInfant = () => {
//     const adultCount = passengerData.filter((p) => p.passengerType === "adult").length;
//     const infantCount = passengerData.filter((p) => p.passengerType === "infant").length;

//     if (infantCount >= adultCount) {
//       Swal.fire("Validation error", "Each infant must be accompanied by an adult.", "error");
//       return;
//     }

//     setPassengerData([...passengerData, {
//       passengerType: "infant",
//       passengerPrefix: "Mstr.",
//       passengerFirstName: "",
//       passengerLastName: "",
//       dob: ""
//     }]);
//   };

//   const calculateTotalPrice = () => {
//     return passengerData.reduce((total, p) => {
//       return total + (p.passengerType === "infant" ? (infant_price + updatedExtraAmount) : price);
//     }, 0);
//   };

//   const handleBookingSubmit = async (e) => {
//     e.preventDefault();

//     if (passengerData.some(p => !p.passengerFirstName || !p.passengerLastName || !p.passengerType || !p.passengerPrefix || (p.passengerType === "infant" && !p.dob))) {
//       Swal.fire("Validation error", "Please fill in all passenger details. Date of birth (yyyy/MM/dd) is required for infants.", "error");
//       return;
//     }

//     const confirm = await Swal.fire({
//       title: "Do you want to confirm this booking?",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes",
//       cancelButtonText: "No",
//         });

//     if (!confirm.isConfirmed) return;

//     const tokenData = JSON.parse(localStorage.getItem("b2bAuthToken") || '{}');
//     const Token = tokenData.token;
//     const externalApiToken = tokenData.externalApiToken;

//     if (!Token || !externalApiToken) {
//       Swal.fire("Authentication failed", "Please log in again.", "error");
//       return;
//     }

//     let userId;
//     let fullName, companyName, phoneNumber;
//     try {
//       const decodedToken = jwtDecode(Token);
//       userId = decodedToken.id || decodedToken.userId;
//       if (!userId) throw new Error("User ID missing in token");
//     } catch (err) {
//       Swal.fire("Token Error", "Invalid or malformed agency token.", "error");
//       return;
//     }
//     console.log("userId is...",userId);


// try {
//   const res = await axios.post(`https://b2bbackend.dxbhabibi.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${userId}`);
//   const agencyData = res.data.data;

//   fullName = agencyData.fullName;
//   companyName = agencyData.companyName;
//   phoneNumber = agencyData.phoneNumber;

//   console.log("Agency details:", fullName, companyName, phoneNumber);
// } catch (err) {
//   console.error("Failed to fetch agency details", err);
//   Swal.fire("Error", "Could not fetch agency details", "error");
//   return; // exit early if agency fetch fails
// }
  

//     const adultInfo = passengerData.filter(p => p.passengerType === "adult");
//     const childInfo = passengerData.filter(p => p.passengerType === "child");
//     const infantInfo = passengerData.filter(p => p.passengerType === "infant");

//     if (childInfo.some(c => !["Mstr.", "Miss"].includes(c.passengerPrefix))) {
//       Swal.fire("Validation error", "Child title must be Mstr. or Miss.", "error");
//       return;
//     }

//     if (infantInfo.length > adultInfo.length) {
//       Swal.fire("Validation error", "Each infant must be accompanied by an adult.", "error");
//       return;
//     }

//     const totalPrice = calculateTotalPrice();

//     const payload = {
//       companyName,
//       fullName,
//       phoneNumber,
//       user_id: userId, // ✅ include user_id
//       ticket_id,
//       total_pax: passengerData.length,
//       total_price: totalPrice,
//       base_price: price,
//       airline,
//       flight_number,
//       pnr,
//       sector,
//       adult: adultInfo.length,
//       child: childInfo.length,
//       infant: infantInfo.length,
//       adult_info: adultInfo.map(p => ({ title: p.passengerPrefix, first_name: p.passengerFirstName, last_name: p.passengerLastName })),
//       child_info: childInfo.map(p => ({ title: p.passengerPrefix, first_name: p.passengerFirstName, last_name: p.passengerLastName })),
//       infant_info: infantInfo.map(p => ({ title: p.passengerPrefix, first_name: p.passengerFirstName, last_name: p.passengerLastName, dob: p.dob })),
//     };

//     try {
//       const res = await fetch("https://b2bbackend.dxbhabibi.com/api/b2/agency/agencyTicketBooking", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: Token,
//           "external-authorization": externalApiToken,
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await res.json();

//       if (res.ok && result.bookingData) {
//         Swal.fire("Booking successful!", "", "success");
//         navigate("/ticket-pdf", {
//           state: {
//             bookingId: result.bookingData.booking_id,
//             userId:userId,
//             companyName:companyName,
//             fullName:fullName,
//             phoneNumber:phoneNumber,
//             total_price: totalPrice,
//             base_price: result.bookingData.base_price,
//           },
//         });
//       } else {
//         Swal.fire("Booking failed....b2bdubai123", result.error || "Server error", "error");
//       }
//     } catch (err) {
//       console.error("Booking error:", err);
//       Swal.fire("Error", "An unexpected error occurred during booking.", "error");
//     }
//   };


//   return (
//     <div className="ticket-booking-container">
//       <div className="flight-ticket-container">
//         <div className="flight-ticket-details">
//           <h4>{origin} → {destination}</h4>
//         </div>
//         <div className="flight-ticket-card">
//           <div className="airline-ticket-detail">
//             <img src={airlineLogo} alt={`${airline} Logo`} className="airline-ticket-logo" />
//             <h4>{airline}</h4>
//           </div>
//           <div className="flight-ticket-info">
//             <p className="flight-ticket-type">{flight_route}</p>
//             <div className="flight-ticket-date">
//               <span>{departure_date !== "N/A" ? new Date(departure_date).toDateString() : "N/A"}</span>
//             </div>
//             <div className="flight-ticket-time">
//               <span>{flight_number}</span>
//               <span>{departure_time} - {arival_time}</span>
//             </div>
//             <p className="seats-ticket-info">Seats: {paxDetails.adults || 1}</p>
//             <div className="booking-ticket-section">
//               <p className="seats-ticket-info">TOUR CODE</p>
//               <h3>AP{price}</h3>
//             </div>
//           </div>
//         </div>
//       </div>

//       <form onSubmit={handleBookingSubmit}>
//         <div className="flight-textbox-container">
//           {passengerData.map((p, i) => (
//             <div key={i} className={p.passengerType === "infant" ? "flight-ticket-infant" : "flight-ticket-selection"}>
//               {p.passengerType !== "infant" && (
//                 <select name="passengerType" value={p.passengerType} onChange={(e) => handlePassengerChange(i, e)}>
//                   <option value="adult">Adult</option>
//                   <option value="child">Child</option>
//                 </select>
//               )}
//               {p.passengerType !== "infant" && (
//                 <select name="passengerPrefix" value={p.passengerPrefix} onChange={(e) => handlePassengerChange(i, e)}>
//                   {p.passengerType === "adult" ? (
//                     <>
//                       <option value="Mr.">Mr.</option>
//                       <option value="Mrs.">Mrs.</option>
//                       <option value="Miss">Miss</option>
//                     </>
//                   ) : (
//                     <>
//                       <option value="Mstr.">Mstr.</option>
//                       <option value="Miss">Miss</option>
//                     </>
//                   )}
//                 </select>
//               )}
//               <input type="text" name="passengerFirstName" placeholder="First Name" value={p.passengerFirstName} onChange={(e) => handlePassengerChange(i, e)} />
//               <input type="text" name="passengerLastName" placeholder="Last Name" value={p.passengerLastName} onChange={(e) => handlePassengerChange(i, e)} />
//               {p.passengerType === "infant" && (
//                 <input
//                   type="text"
//                   name="dob"
//                   placeholder="DOB yyyy/MM/dd"
//                   value={p.dob || ""}
//                   onChange={(e) => handlePassengerChange(i, e)}
//                 />
//               )}
//             </div>
//           ))}
//         </div>

//         <button type="button" className="infant-button" onClick={addInfant}>Add Infant (AED {infant_price + updatedExtraAmount})</button>

//         <div className="flight-ticket-container">
//           <div className="flight-ticket-terms">
//             <h3>Total Price: AED {calculateTotalPrice()}</h3>
//           </div>
//         </div>

//         <div className="flight-ticket-submit">
//           <div className="flight-ticket-terms">
//             <p>I have read and agree to the <span>Terms & Conditions</span></p>
//             <button type="submit" className="submit-ticket-button">Submit Booking</button>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default TicketBooking;
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import "../Styles/TicketBooking.css";
import axios from "axios";

const TicketBooking = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchDetails = location.state?.flight || {};
  const paxDetails = location.state?.seats || {};
  const updatedExtraAmount = location.state?.updatedPrice || {};

  // ✅ FIX: convert updatedExtraAmount into a number safely
  const extraAmount =
    typeof updatedExtraAmount === "number"
      ? updatedExtraAmount
      : Number(
          updatedExtraAmount?.amount ||
          updatedExtraAmount?.price ||
          updatedExtraAmount?.fee ||
          0
        );

  console.log("Extra Amount (number):", extraAmount);

  const {
    origin = "N/A",
    destination = "N/A",
    airline = "N/A",
    departure_date = "N/A",
    departure_time = "N/A",
    arival_time = "N/A",
    pnr = "N/A",
    sector = "N/A",
    flight_number = "N/A",
    flight_route = "N/A",
    ticket_id = "N/A",
    price = 0,
    infant_price = 0,
  } = searchDetails;

  const airlineLogos = {
    SpiceJet: "https://airiq.in/img/spicejet.png",
    IndiGo: "https://airiq.in/img/indigo.png",
    Vistara: "https://airiq.in/img/vistara.png",
    AirIndia: "https://airiq.in/img/airindia.png",
  };

  const airlineLogo =
    airlineLogos[airline] ||
    "https://thumbs.dreamstime.com/b/small-airplane-flight-4023457.jpg";

  const [passengerData, setPassengerData] = useState(() => {
    const adults = Array.from({ length: paxDetails.adults || 1 }, () => ({
      passengerType: "adult",
      passengerPrefix: "Mr.",
      passengerFirstName: "",
      passengerLastName: "",
    }));

    const children = Array.from({ length: paxDetails.children || 0 }, () => ({
      passengerType: "child",
      passengerPrefix: "Mstr.",
      passengerFirstName: "",
      passengerLastName: "",
    }));

    return [...adults, ...children];
  });

  const handlePassengerChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...passengerData];

    updated[index] = { ...updated[index], [name]: value };

    if (name === "passengerType") {
      updated[index].passengerPrefix =
        value === "adult" ? "Mr." : value === "child" ? "Mstr." : "";
    }

    setPassengerData(updated);
  };

  const addInfant = () => {
    const adultCount = passengerData.filter(p => p.passengerType === "adult").length;
    const infantCount = passengerData.filter(p => p.passengerType === "infant").length;

    if (infantCount >= adultCount) {
      Swal.fire("Validation error", "Each infant must be accompanied by an adult.", "error");
      return;
    }

    setPassengerData([
      ...passengerData,
      {
        passengerType: "infant",
        passengerPrefix: "Mstr.",
        passengerFirstName: "",
        passengerLastName: "",
        dob: "",
      },
    ]);
  };

  // ✅ FIXED price calculation
  const calculateTotalPrice = () => {
    return passengerData.reduce((total, p) => {
      if (p.passengerType === "infant") {
        return total + infant_price + extraAmount;
      }
      return total + price;
    }, 0);
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();

    if (
      passengerData.some(
        p =>
          !p.passengerFirstName ||
          !p.passengerLastName ||
          (p.passengerType === "infant" && !p.dob)
      )
    ) {
      Swal.fire("Validation error", "Please fill all passenger details", "error");
      return;
    }

    const confirm = await Swal.fire({
      title: "Confirm booking?",
      icon: "question",
      showCancelButton: true,
    });

    if (!confirm.isConfirmed) return;

    const tokenData = JSON.parse(localStorage.getItem("b2bAuthToken") || "{}");
    const Token = tokenData.token;
    const externalApiToken = tokenData.externalApiToken;

    if (!Token || !externalApiToken) {
      Swal.fire("Authentication failed", "Please login again", "error");
      return;
    }

    let userId, fullName, companyName, phoneNumber;

    try {
      const decoded = jwtDecode(Token);
      userId = decoded.id || decoded.userId;
    } catch {
      Swal.fire("Token error", "Invalid token", "error");
      return;
    }

    try {
      const res = await axios.post(
        `https://b2bbackend.dxbhabibi.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${userId}`
      );
      ({ fullName, companyName, phoneNumber } = res.data.data);
    } catch {
      Swal.fire("Error", "Could not fetch agency details", "error");
      return;
    }

    const totalPrice = calculateTotalPrice();

    const payload = {
      companyName,
      fullName,
      phoneNumber,
      user_id: userId,
      ticket_id,
      total_pax: passengerData.length,
      total_price: totalPrice,
      base_price: price,
      airline,
      flight_number,
      pnr,
      sector,
      adult: passengerData.filter(p => p.passengerType === "adult").length,
      child: passengerData.filter(p => p.passengerType === "child").length,
      infant: passengerData.filter(p => p.passengerType === "infant").length,
    };

    try {
      const res = await fetch(
        "https://b2bbackend.dxbhabibi.com/api/b2/agency/agencyTicketBooking",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: Token,
            "external-authorization": externalApiToken,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await res.json();

      if (res.ok) {
        Swal.fire("Booking successful!", "", "success");
        navigate("/ticket-pdf", { state: { userId, totalPrice } });
      } else {
        Swal.fire("Booking failed", result.error || "Server error", "error");
      }
    } catch {
      Swal.fire("Error", "Unexpected error", "error");
    }
  };

  // return (
  //   <div className="ticket-booking-container">
  //     <form onSubmit={handleBookingSubmit}>
  //       <button
  //         type="button"
  //         className="infant-button"
  //         onClick={addInfant}
  //       >
  //         Add Infant (AED {infant_price + extraAmount})
  //       </button>

  //       <h3>Total Price: AED {calculateTotalPrice()}</h3>

  //       <button type="submit" className="submit-ticket-button">
  //         Submit Booking
  //       </button>
  //     </form>
  //   </div>
  // );
  return (
  <div className="ticket-booking-container">
    <div className="flight-ticket-container">
      <div className="flight-ticket-details">
        <h4>{origin} → {destination}</h4>
      </div>

      <div className="flight-ticket-card">
        <div className="airline-ticket-detail">
          <img
            src={airlineLogo}
            alt={`${airline} Logo`}
            className="airline-ticket-logo"
          />
          <h4>{airline}</h4>
        </div>

        <div className="flight-ticket-info">
          <p className="flight-ticket-type">{flight_route}</p>

          <div className="flight-ticket-date">
            <span>
              {departure_date !== "N/A"
                ? new Date(departure_date).toDateString()
                : "N/A"}
            </span>
          </div>

          <div className="flight-ticket-time">
            <span>{flight_number}</span>
            <span>{departure_time} - {arival_time}</span>
          </div>

          <p className="seats-ticket-info">
            Seats: {paxDetails.adults || 1}
          </p>

          <div className="booking-ticket-section">
            <p className="seats-ticket-info">TOUR CODE</p>
            <h3>AED {price}</h3>
          </div>
        </div>
      </div>
    </div>

    <form onSubmit={handleBookingSubmit}>
      <div className="flight-textbox-container">
        {passengerData.map((p, i) => (
          <div
            key={i}
            className={
              p.passengerType === "infant"
                ? "flight-ticket-infant"
                : "flight-ticket-selection"
            }
          >
            {p.passengerType !== "infant" && (
              <select
                name="passengerType"
                value={p.passengerType}
                onChange={(e) => handlePassengerChange(i, e)}
              >
                <option value="adult">Adult</option>
                <option value="child">Child</option>
              </select>
            )}

            {p.passengerType !== "infant" && (
              <select
                name="passengerPrefix"
                value={p.passengerPrefix}
                onChange={(e) => handlePassengerChange(i, e)}
              >
                {p.passengerType === "adult" ? (
                  <>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Miss">Miss</option>
                  </>
                ) : (
                  <>
                    <option value="Mstr.">Mstr.</option>
                    <option value="Miss">Miss</option>
                  </>
                )}
              </select>
            )}

            <input
              type="text"
              name="passengerFirstName"
              placeholder="First Name"
              value={p.passengerFirstName}
              onChange={(e) => handlePassengerChange(i, e)}
            />

            <input
              type="text"
              name="passengerLastName"
              placeholder="Last Name"
              value={p.passengerLastName}
              onChange={(e) => handlePassengerChange(i, e)}
            />

            {p.passengerType === "infant" && (
              <input
                type="text"
                name="dob"
                placeholder="DOB yyyy/MM/dd"
                value={p.dob || ""}
                onChange={(e) => handlePassengerChange(i, e)}
              />
            )}
          </div>
        ))}
      </div>

      {/* ✅ FIXED BUTTON */}
      <button
        type="button"
        className="infant-button"
        onClick={addInfant}
      >
        Add Infant (AED {infant_price + extraAmount})
      </button>

      <div className="flight-ticket-container">
        <div className="flight-ticket-terms">
          <h3>Total Price: AED {calculateTotalPrice()}</h3>
        </div>
      </div>

      <div className="flight-ticket-submit">
        <div className="flight-ticket-terms">
          <p>
            I have read and agree to the <span>Terms & Conditions</span>
          </p>
          <button type="submit" className="submit-ticket-button">
            Submit Booking
          </button>
        </div>
      </div>
    </form>
  </div>
);

};

export default TicketBooking;
